import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from './firebase'
import pusher from 'vue-pusher';
import Chat from 'vue-beautiful-chat'
import Notify from 'mdbvue/lib/components/Notify'
import VueHtmlToPaper from 'vue-html-to-paper';

Vue.config.productionTip = false

//initiate firebase
if(firebase!=null){
  //initialized firebase messaging
  if(firebase.messaging.isSupported()){
    Vue.prototype.$messaging = firebase.messaging();
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      Vue.prototype.$messaging.useServiceWorker(registration)
    }).catch(err => {
        console.log(err)
    })
  }
  Vue.prototype.$firestore=firebase.firestore();
}

Vue.use(Notify);
Vue.use(Chat);
Vue.use(VueHtmlToPaper);
Vue.use(pusher, {
  api_key: 'b6602a4877b4bb013240',
  options: {
    cluster: 'ap1',
    encrypted: true,
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
